import React, { Component } from "react";

import httpClient from '../../httpClient'
import { Button, Modal, ModalBody , Form, FormGroup,  Input } from 'reactstrap';
import { withRouter } from "react-router-dom";


class LoginSuoerAdminForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
          modalSuperAdmin:this.props.form,
          fields: {email: '', password: ''}
    
        };
    
        this.toggleSuperAdmin = this.toggleSuperAdmin.bind(this);
        
      }

      toggleSuperAdmin() {
        this.setState({
          modalSuperAdmin: !this.state.modalSuperAdmin
        });
      }


      onInputChange(evt) {
		this.setState({
			fields: {
				...this.state.fields,
				[evt.target.name]: evt.target.value
			}
    })
  }

      onFormSubmitSuperAdmin(evt) {
		evt.preventDefault()
		httpClient.logIn(this.state.fields).then(user => {
      this.setState({ fields: { email: '', password: '' } })
      if(1){
        this.setState({
          modalSuperAdmin:false
              });
      this.props.history.push(`/super_admin`);
      console.log("success");    
      }

		})
    }
    



    // onFormSubmitSuperAdmin(evt) {
		// evt.preventDefault()
		// httpClient.logIn(this.state.fields).then(user => {
    //   this.setState({ fields: { email: '', password: '' } })
    //   if(user.admin){
    //   this.props.history.push(`/super_admin`);
    //   }
		// 	if(user) {
    //     this.props.onLoginSuccess(user)
    //     this.setState({
    //       modalsuperAdmin:false
    //     });
		// 	}
		// })
    // }


    

  render() {
    const {name, password } = this.state.fields

    return (
        <div>
        <Modal isOpen={this.state.modalSuperAdmin} toggle={this.toggleSuperAdmin} className={this.props.className}>
          {/* <ModalHeader toggle={this.toggle}>Modal title</ModalHeader> */}
          <img src='imgs/logo/Group_83.svg' alt='logo' className="logo-login-modal"  />
          <ModalBody>
            <Form className="form-login" onChange={this.onInputChange.bind(this)} onSubmit={this.onFormSubmitSuperAdmin.bind(this)} style={{marginBottom:"10px"}}>
            <div className="title-center" style={{fontWeight:"bold"}}>Welcome Super Admin</div>

              <FormGroup>
                <Input type="email" name="email" id="exampleEmail" placeholder="Adress e-mail" className="placeholder-center" value={name}></Input>
              </FormGroup>

              <FormGroup>
                  <Input type="password" className="placeholder-center" name="password" id="examplePassword" placeholder="Mot de passe" value={password}/>
              </FormGroup>
              <FormGroup>

              <Button className="submit-button" style={{backgroundColor:"#39296a",marginBottom:"107px",borderRadius:"11px"}}>Se Connecter</Button>

              </FormGroup>



            </Form>
            </ModalBody>
          </Modal>
          </div>
    );
  }
}

export default  withRouter(LoginSuoerAdminForm);